export default __webpack_public_path__ + "static/media/planning.2fb58980.jpg";